module.exports = __webpack_public_path__ + "img/u@2x(1).8dbb723e.png";